import BaseView from '@app/List/View'

export default function plugin(Vue, { postfix = '-filters' } = { }) {
  Vue.component(`map${postfix}`, BaseView)
  Vue.component('cabinet-list-view', BaseView)
}
